
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import { EventService } from '../services/event.service';
import {first, map} from "rxjs/operators";

@Injectable()
export class DonationAmountsResolver implements Resolve<any> {
    constructor(
        private eventService: EventService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any>|Promise<any>|any {
        const isNationalTeamPage = !!route.queryParams['isNationalTeamPage'];
        if(!isNationalTeamPage) {
            return this.eventService.getDonationAmounts(this.getFundraiserId(route))
                .pipe(map(res => res.Fundraiser[0].fundraiserDonationAmountRangeTypes)
                ,first());
        } else {
            return observableOf({});
        }
    }

    getFundraiserId(route) {
        let isTeam = !!route.queryParams['isTeam'];
        if (isTeam) {
            return this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserId;
        } else {
            return this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserId;
        }
    }
}
